// Failed logins on this device (audit-full F-9): from the 3rd wrong password for an address the next try waits 5 s, then 10, 20 ...
// up to 60 s, with a message. A browser-side brake only - the real limit is Supabase Auth's own rate limit on the server.
// state = { [email]: { n: failures, until: ms } }, kept in localStorage so a reload does not reset it.
export const FREE_TRIES = 3, BASE_WAIT = 5000, MAX_WAIT = 60000
const KEY = 'hc_login_fails'
const keyOf = email => String(email || '').trim().toLowerCase()
export const waitAfter = n => (n < FREE_TRIES ? 0 : Math.min(MAX_WAIT, BASE_WAIT * 2 ** (n - FREE_TRIES)))

export function readState(store) { try { return JSON.parse((store || localStorage).getItem(KEY) || '{}') || {} } catch (e) { return {} } }
function writeState(st, store) { try { (store || localStorage).setItem(KEY, JSON.stringify(st)) } catch (e) {} }

// ms left before this address may try again (0 = now)
export function waitLeft(email, now = Date.now(), store) { const r = readState(store)[keyOf(email)]; return r && r.until > now ? r.until - now : 0 }
// a wrong password: count it, set the wait -> { n, wait }
export function recordFailure(email, now = Date.now(), store) {
  const st = readState(store), k = keyOf(email), n = ((st[k] && st[k].n) || 0) + 1, wait = waitAfter(n)
  st[k] = { n, until: now + wait }; writeState(st, store)
  return { n, wait }
}
export function recordSuccess(email, store) { const st = readState(store); delete st[keyOf(email)]; writeState(st, store) }
export const waitMessage = ms => 'Too many failed attempts. Please wait ' + Math.ceil(ms / 1000) + ' s before trying again - or use "Forgot password" below.'
